const RELATED_SPINNER_SVG = `<svg class="spinner--root" style="display:block; shape-rendering:auto;" width="41px" height="41px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
    <g transform="rotate(0 50 50)"><rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.8391608391608392s" repeatCount="indefinite"></animate></rect></g>
    <g transform="rotate(27.692307692307693 50 50)"><rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.7692307692307692s" repeatCount="indefinite"></animate></rect></g>
    <g transform="rotate(55.38461538461539 50 50)"><rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.6993006993006993s" repeatCount="indefinite"></animate></rect></g>
    <g transform="rotate(83.07692307692308 50 50)"><rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.6293706293706294s" repeatCount="indefinite"></animate></rect></g>
    <g transform="rotate(110.76923076923077 50 50)"><rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.5594405594405594s" repeatCount="indefinite"></animate></rect></g>
    <g transform="rotate(138.46153846153845 50 50)"><rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.4895104895104895s" repeatCount="indefinite"></animate></rect></g>
    <g transform="rotate(166.15384615384616 50 50)"><rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.4195804195804196s" repeatCount="indefinite"></animate></rect></g>
    <g transform="rotate(193.84615384615384 50 50)"><rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.34965034965034963s" repeatCount="indefinite"></animate></rect></g>
    <g transform="rotate(221.53846153846155 50 50)"><rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.2797202797202797s" repeatCount="indefinite"></animate></rect></g>
    <g transform="rotate(249.23076923076923 50 50)"><rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.2097902097902098s" repeatCount="indefinite"></animate></rect></g>
    <g transform="rotate(276.9230769230769 50 50)"><rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.13986013986013984s" repeatCount="indefinite"></animate></rect></g>
    <g transform="rotate(304.61538461538464 50 50)"><rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.06993006993006992s" repeatCount="indefinite"></animate></rect></g>
    <g transform="rotate(332.3076923076923 50 50)"><rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="0s" repeatCount="indefinite"></animate></rect></g>
</svg>`;

class CartDrawer extends HTMLElement {
    #overlay = null;
    #isRefreshing = false;
    #swiperInstance = null;
    #relatedSwiperInstance = null;

    // Mattress ke saath aane wala free product variant ID
    freeProductVariantId = '45489477681328';

    constructor() {
        super();
        this.openDrawer = this.openDrawer.bind(this);
        this.closeDrawer = this.closeDrawer.bind(this);
        this.handleOverlayClick = this.handleOverlayClick.bind(this);
        this.refreshDrawer = this.refreshDrawer.bind(this);
        this.handleAddToCart = this.#handleAddToCart.bind(this);
    }

    connectedCallback() {
        this.#overlay = document.querySelector('.side-cart-overlay');
        this.#overlay?.addEventListener('click', this.handleOverlayClick);

        document.addEventListener('side-cart:drawer:open', this.openDrawer);
        document.addEventListener('side-cart:drawer:close', this.closeDrawer);
        document.addEventListener('side-cart:drawer:refresh', this.refreshDrawer);

        this.addEventListener('click', this.#handleDelete.bind(this));
        this.addEventListener('click', this.#handleQtyUpdate.bind(this));
        this.addEventListener('click', this.#handleRelatedNav.bind(this));

        document.addEventListener('click', this.handleAddToCart);

        this.#initSwiper();
        this.#reinitExternalListeners();
    }

    disconnectedCallback() {
        this.#overlay?.removeEventListener('click', this.handleOverlayClick);
        document.removeEventListener('side-cart:drawer:open', this.openDrawer);
        document.removeEventListener('side-cart:drawer:close', this.closeDrawer);
        document.removeEventListener('side-cart:drawer:refresh', this.refreshDrawer);
        document.removeEventListener('click', this.handleAddToCart);
        this.#destroySwiper();
        this.#destroyRelatedSwiper();
    }

    #reinitExternalListeners() {
        this.qtyValue = document.querySelector('.product__offer_qty .qty__value');
        this.#offerQty();
    }

    openDrawer() {
        this.setAttribute('open', '');
        this.#overlay?.classList.add('is-visible');
        document.body.classList.add('overflow-hidden');
        this.removeAttribute('loading');
        this.getRelatedProducts();
    }

    closeDrawer() {
        this.removeAttribute('open');
        this.#overlay?.classList.remove('is-visible');
        document.body.classList.remove('overflow-hidden');
    }

    handleOverlayClick() {
        this.closeDrawer();
    }

    async refreshDrawer(event) {
        if (this.#isRefreshing) return;
        this.#isRefreshing = true;
        this.setAttribute('loading', '');

        try {

            await this.#syncFreeProduct();


            const [sectionsRes, cartRes] = await Promise.all([
                fetch(`${window.location.pathname}?sections=new-side-cart-drawer`, {
                    headers: { 'Content-Type': 'application/json' }
                }),
                fetch('/cart.js')
            ]);

            if (!sectionsRes.ok) throw new Error(`Section fetch failed: ${sectionsRes.status}`);
            if (!cartRes.ok) throw new Error(`Cart fetch failed: ${cartRes.status}`);

            const [data, cart] = await Promise.all([
                sectionsRes.json(),
                cartRes.json()
            ]);

            const sectionHTML = data['new-side-cart-drawer'];
            if (!sectionHTML) throw new Error('Section HTML missing in response');

            const newDrawer = new DOMParser()
                .parseFromString(sectionHTML, 'text/html')
                .querySelector('cart-drawer');

            if (newDrawer) {
                const wasOpen = this.hasAttribute('open');
                this.innerHTML = newDrawer.innerHTML;

                this.#initSwiper();
                this.#reinitExternalListeners();

                if (wasOpen) this.setAttribute('open', '');
            }

            const count = cart.item_count ?? 0;
            document.querySelectorAll('#cartItemCount, .cart_drawer_count')
                .forEach(el => el.textContent = count);

        } catch (err) {
            console.error('[CartDrawer]', err);
        } finally {
            this.#isRefreshing = false;

            if (event?.detail?.onComplete) {
                event.detail.onComplete();
            } else {
                this.removeAttribute('loading');
            }
        }

        this.getRelatedProducts();
    }

    async #handleDelete(event) {
        const btn = event.target.closest('.delete-btn');
        if (!btn) return;

        const key = btn.dataset.key;
        if (!key) return;

        btn.disabled = true;
        this.#setItemSkeleton(key, true);

        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: 0 })
            });

            if (!response.ok) throw new Error(`Delete failed: ${response.status}`);

            document.dispatchEvent(new CustomEvent('side-cart:drawer:refresh'));

        } catch (err) {
            console.error('[CartDrawer] Delete error:', err);
            btn.disabled = false;
            this.#setItemSkeleton(key, false);
        }
    }

    async #handleQtyUpdate(event) {
        const btn = event.target.closest('.qty-btn');
        if (!btn) return;

        const key = btn.dataset.key;
        const currentQty = parseInt(btn.dataset.quantity);
        const isMinus = btn.classList.contains('minus');
        const newQty = isMinus ? currentQty - 1 : currentQty + 1;

        const qtyWrapper = btn.closest('.cart-item__qty');
        qtyWrapper?.querySelectorAll('.qty-btn').forEach(b => b.disabled = true);
        this.#setQtySkeleton(key, true);

        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: newQty })
            });

            if (!response.ok) throw new Error(`Qty update failed: ${response.status}`);

            document.dispatchEvent(new CustomEvent('side-cart:drawer:refresh'));

        } catch (err) {
            console.error('[CartDrawer] Qty update error:', err);
            qtyWrapper?.querySelectorAll('.qty-btn').forEach(b => b.disabled = false);
            this.#setQtySkeleton(key, false);
        }
    }

    // Related product carousel ke prev/next arrows
    #handleRelatedNav(event) {
        const prevBtn = event.target.closest('.prev__related__button');
        const nextBtn = event.target.closest('.next__related__button');

        if (prevBtn && this.#relatedSwiperInstance) {
            this.#relatedSwiperInstance.slidePrev();
        } else if (nextBtn && this.#relatedSwiperInstance) {
            this.#relatedSwiperInstance.slideNext();
        }
    }

    // Cart me free product (pillow) already hai ya nahi ye check karega
    async #isFreeProductInCart() {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();

            return cart.items.some(
                (item) =>
                    String(item.variant_id) ===
                    String(this.freeProductVariantId)
            );
        } catch (error) {
            console.error('[CartDrawer] Free Product Check Error:', error);
            // Fail ho jaye to safe side lene ke liye false (taaki free product miss na ho)
            return false;
        }
    }

    // Delegated — main ATC widget + related product cards, dono ke liye
    async #handleAddToCart(event) {
        const btn = event.target.closest('.product__show__case__atc');
        if (!btn || btn.disabled) return;

        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        const isRelated = !!btn.closest('.side-cart-related-product-container');
        const qty = isRelated
            ? 1
            : (Number(this.qtyValue?.textContent) || 1);

        const productType = btn.dataset.productType;
        const isMattress =
            productType === 'MATTRESS' ||
            productType === 'Mattress';

        const textEl = btn.querySelector('.cart__atc__text');
        const loaderEl = btn.querySelector('.cart__atc__loeader');

        btn.disabled = true;
        if (textEl) textEl.style.display = 'none';
        if (loaderEl) loaderEl.style.display = 'flex';

        try {
            let payload;

            if (isMattress) {

                const alreadyHasFreeProduct = await this.#isFreeProductInCart();

                console.log(
                    '[CartDrawer] Free Product Already In Cart:',
                    alreadyHasFreeProduct
                );

                const items = [
                    {
                        id: variantId,
                        quantity: qty,
                        properties: {
                            _is_mattress: true
                        }
                    }
                ];

                // Free product tabhi push karo jab cart me already na ho
                if (!alreadyHasFreeProduct) {
                    items.push({
                        id: this.freeProductVariantId,
                        quantity: 1,
                        properties: {
                            _free_product: true
                        }
                    });
                }

                payload = { items };

            } else {

                payload = {
                    items: [
                        {
                            id: variantId,
                            quantity: qty,
                            properties: {
                                _is_mattress: false
                            }
                        }
                    ]
                };
            }

            console.log('[CartDrawer] ATC Payload:', payload);

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (!response.ok) throw new Error(`Add to cart failed: ${response.status}`);

            document.dispatchEvent(new CustomEvent('side-cart:drawer:refresh'));

        } catch (err) {
            console.error('[CartDrawer] ATC error:', err);
        } finally {
            btn.disabled = false;
            if (textEl) textEl.style.display = 'block';
            if (loaderEl) loaderEl.style.display = 'none';
        }
    }

    async #syncFreeProduct() {
    const isTruthy = (val) => val === true || val === 'true';

    try {
        const cart = await fetch('/cart.js').then(res => res.json());

        const hasMattress = cart.items.some(item => isTruthy(item.properties?._is_mattress));
        const freeProductItem = cart.items.find(item => isTruthy(item.properties?._free_product));

        if (!hasMattress && freeProductItem) {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: freeProductItem.key, quantity: 0 })
            });
        }
    } catch (err) {
        console.error('[CartDrawer] syncFreeProduct error:', err);
    }
}

    #setItemSkeleton(key, isLoading) {
        const item = this.querySelector(`[data-item-key="${key}"]`);
        if (!item) return;

        [
            '.cart-item__image',
            '.cart-item__title',
            '.cart-item__variant',
            '.cart-item__qty',
            '.cart-item__price',
            '.cart-item__compare',
            '.delete-btn'
        ].forEach(selector => {
            item.querySelector(selector)?.classList.toggle('skeleton', isLoading);
        });
    }

    #setQtySkeleton(key, isLoading) {
        const item = this.querySelector(`[data-item-key="${key}"]`);

        [
            item?.querySelector('.cart-item__qty'),
            item?.querySelector('.cart-item__price'),
            item?.querySelector('.cart-item__compare'),
            this.querySelector('.side__cart__total > .total_price'),
            this.querySelector('.checkout__button')
        ].forEach(el => {
            el?.classList.toggle('skeleton', isLoading);
        });
    }

    #initSwiper() {
        this.#destroySwiper();

        const el = this.querySelector('.mySwiperCartDrawerNew');
        if (!el) return;

        this.#swiperInstance = new Swiper(el, {
            spaceBetween: 20,
            slidesPerView: 2.5,
            breakpoints: {
                0: { slidesPerView: 1.5 },
                768: { slidesPerView: 2.5 }
            }
        });
    }

    #destroySwiper() {
        this.#swiperInstance?.destroy(true, true);
        this.#swiperInstance = null;
    }

    #destroyRelatedSwiper() {
        this.#relatedSwiperInstance?.destroy(true, true);
        this.#relatedSwiperInstance = null;
    }

    #offerQty() {
        const qtyButtons = document.querySelectorAll('.qty__btn');
        const qtyElement = this.qtyValue;

        if (!qtyElement) return;

        qtyButtons.forEach(btn => {
            const fresh = btn.cloneNode(true);
            btn.replaceWith(fresh);

            fresh.addEventListener('click', () => {
                const action = fresh.dataset.action;
                let value = parseInt(qtyElement.textContent) || 1;

                if (action === 'plus') {
                    value++;
                } else if (action === 'minus' && value > 1) {
                    value--;
                }

                qtyElement.textContent = value;
            });
        });
    }

    async getRelatedProducts() {
        const RELATED_LIMIT = 5;

        try {
            const cart = await fetch('/cart.js').then(res => res.json());

            if (!cart.items.length) {
                this.#destroyRelatedSwiper();
                this.appendRelatedProducts([]);
                return;
            }

            const cartIds = cart.items.map(item => item.product_id);

            const results = await Promise.all(
                cart.items.map(item =>
                    fetch(`/recommendations/products.json?product_id=${item.product_id}&limit=${RELATED_LIMIT}&intent=related`)
                        .then(res => res.json())
                        .catch(err => {
                            console.error('[CartDrawer] recommendation fetch error:', err);
                            return { products: [] };
                        })
                )
            );

            let products = results.flatMap(data => data.products || []);
            products = [...new Map(products.map(p => [p.id, p])).values()];
            products = products.filter(product => !cartIds.includes(product.id));

            if (!products.length) {
                const fallbackData = await fetch(`/products.json?limit=${RELATED_LIMIT + cartIds.length}`)
                    .then(res => res.json())
                    .catch(() => ({ products: [] }));

                products = (fallbackData.products || [])
                    .filter(product => !cartIds.includes(product.id))
                    .map(product => ({
                        id: product.id,
                        title: product.title,
                        url: `/products/${product.handle}`,
                        featured_image: product.images?.[0]?.src,
                        variants: product.variants,
                        product_type: product.product_type
                    }));
            }

            products = products.slice(0, RELATED_LIMIT);

            this.appendRelatedProducts(products);

        } catch (err) {
            console.error('[CartDrawer] getRelatedProducts error:', err);
        }
    }

    appendRelatedProducts(products) {
        const container = this.querySelector('.side-cart-related-product')
            || document.querySelector('.side-cart-related-product');

        if (!container) {
            console.warn('[CartDrawer] .side-cart-related-product not found — check Liquid markup');
            return;
        }

        const swiperWrapper = container.querySelector('.swiper-wrapper');
        const outerWrapper = container.closest('.side-cart-related-product-container');

        if (!swiperWrapper) {
            console.warn('[CartDrawer] .swiper-wrapper not found inside .side-cart-related-product');
            return;
        }

        this.#destroyRelatedSwiper();

        console.log('[CartDrawer] rendering related products:', products);

        if (!products.length) {
            if (outerWrapper) outerWrapper.style.display = 'none';
            swiperWrapper.innerHTML = '';
            return;
        }

        if (outerWrapper) outerWrapper.style.display = '';

        const safeFormatMoney = (amount) => {
            try {
                if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
                    return Shopify.formatMoney(amount);
                }
            } catch (e) {
                console.warn('[CartDrawer] Shopify.formatMoney failed, using fallback', e);
            }
            const num = Number(amount) / (Number(amount) > 1000 ? 100 : 1);
            return `Rs. ${num.toLocaleString('en-IN')}`;
        };

        const slidesHTML = products.map(product => {
            try {
                const variant = product.variants?.[0] || {};
                const price = variant.price ?? product.price ?? 0;
                const comparePrice = variant.compare_at_price ?? product.compare_at_price;
                const hasDefaultTitle = variant.title === "Default Title" ? true : false;
                const hasDiscount = comparePrice && Number(comparePrice) > Number(price);
                const discountPercent = hasDiscount
                    ? Math.round((1 - price / comparePrice) * 100)
                    : 0;

                return `
                <div class="swiper-slide related-swiper-slide">
                    <img src="${product.featured_image || ''}" alt="${product.title || ''}">
                    <div class="card__content">
                        <a class="card__title" href="javascript:void(0)">
                            ${product.title || ''}
                        </a>
                       ${!hasDefaultTitle ? `<span>${variant.title}</span>` : ""}
                        
                        <div class="price__container">
                            <span class="selling__price">
                                ${safeFormatMoney(price)}
                            </span>
                            ${hasDiscount ? `
                                <span class="mrp__price">${safeFormatMoney(comparePrice)}</span>
                                <span class="discount__tag">${discountPercent}%</span>
                            ` : ''}
                        </div>
                        <button class="product__show__case__atc" data-variant-id="${variant.id || ''}" data-product-id="${product.id || ''}" data-product-type="no_offer">
                            <span class="cart__atc__text">Add To Cart</span>
                            <span class="cart__atc__loeader" style="display:none;">${RELATED_SPINNER_SVG}</span>
                        </button>
                    </div>
                </div>
            `;
            } catch (err) {
                console.error('[CartDrawer] error rendering product:', product, err);
                return '';
            }
        }).join('');

        console.log('[CartDrawer] final slidesHTML length:', slidesHTML.length);

        swiperWrapper.innerHTML = slidesHTML;

        this.initRelatedSwiper();
    }

    initRelatedSwiper() {
        const el = this.querySelector('.siderCartRelatedProduct')
            || document.querySelector('.siderCartRelatedProduct');

        if (!el) return;

        this.#relatedSwiperInstance = new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: false
        });
    }
}

if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
}